var swiper = new Swiper('.blog-grid-card .bgc-swiper', {
    spaceBetween: 10,
    slidesPerView: 1.25,
    grabCursor: true,
    keyboard: true,
    navigation: {
        nextEl: '.blog-grid-card .bgc-pagination .swiper-button-next',
        prevEl: '.blog-grid-card .bgc-pagination .swiper-button-prev',
    },
    breakpoints: {
        769: {
            spaceBetween: 15,
            slidesPerView: 2
        },
        1024: {
            spaceBetween: 18,
            slidesPerView: 2.50
        },
        1280: {
            spaceBetween: 20,
            slidesPerView: 3
        }
    }
});